document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-proof-dials]');
  if (sections.length === 0) return;

  const RADIUS = 46;
  const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
  const DURATION = 900;

  const easeOutQuad = (t) => t * (2 - t);

  const setArcOffset = (arc, percentage) => {
    const offset = CIRCUMFERENCE * (1 - Math.min(100, Math.max(0, percentage)) / 100);
    arc.style.strokeDashoffset = offset;
  };

  const resetMetric = (metric) => {
    const arc = metric.querySelector('.lh-landings-proof-dials__dial-arc');
    const value = metric.querySelector('[data-dial-value]');
    if (arc) {
      arc.style.transition = 'none';
      arc.style.strokeDasharray = CIRCUMFERENCE;
      arc.style.strokeDashoffset = CIRCUMFERENCE;
      arc.getBoundingClientRect();
    }
    if (value) {
      const suffix = metric.dataset.suffix || '%';
      value.textContent = `0${suffix}`;
    }
  };

  const animateMetric = (metric) => {
    const arc = metric.querySelector('.lh-landings-proof-dials__dial-arc');
    const valueEl = metric.querySelector('[data-dial-value]');
    if (!arc || !valueEl) return;

    const targetPercentage = parseFloat(metric.dataset.percentage) || 0;
    const suffix = metric.dataset.suffix || '%';
    const targetValue = targetPercentage; // number shown matches percentage

    resetMetric(metric);

    requestAnimationFrame(() => {
      arc.style.transition = `stroke-dashoffset ${DURATION}ms ease`;
      setArcOffset(arc, targetPercentage);
    });

    let start = null;
    const step = (timestamp) => {
      if (!start) start = timestamp;
      const progress = Math.min(1, (timestamp - start) / DURATION);
      const eased = easeOutQuad(progress);
      const current = targetValue * eased;
      valueEl.textContent = `${current.toFixed(current % 1 === 0 ? 0 : 1)}${suffix}`;
      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };
    requestAnimationFrame(step);
  };

  const activateTab = (section, key, shouldAnimate) => {
    const tabs = section.querySelectorAll('[data-proof-tab]');
    const visuals = section.querySelectorAll('[data-proof-visual]');
    const panels = section.querySelectorAll('[data-proof-panel]');
    const footnotes = section.querySelectorAll('[data-proof-footnote]');

    tabs.forEach((tab) => {
      const isTarget = tab.dataset.proofTab === key;
      tab.classList.toggle('is-active', isTarget);
      tab.setAttribute('aria-selected', isTarget ? 'true' : 'false');
    });

    visuals.forEach((visual) => {
      visual.classList.toggle('is-active', visual.dataset.proofVisual === key);
    });

    footnotes.forEach((footnote) => {
      footnote.classList.toggle('is-active', footnote.dataset.proofFootnote === key);
    });

    panels.forEach((panel) => {
      const isTarget = panel.dataset.proofPanel === key;
      panel.classList.toggle('is-active', isTarget);
      if (isTarget && shouldAnimate) {
        const metrics = panel.querySelectorAll('[data-proof-metric]');
        metrics.forEach((metric, index) => {
          resetMetric(metric);
          setTimeout(() => animateMetric(metric), index * 80);
        });
      }
    });
  };

  sections.forEach((section) => {
    const tabs = section.querySelectorAll('[data-proof-tab]');
    const metrics = section.querySelectorAll('[data-proof-metric]');

    metrics.forEach((metric) => resetMetric(metric));

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        activateTab(section, tab.dataset.proofTab, true);
      });
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !section.dataset.proofAnimated) {
            section.dataset.proofAnimated = 'true';
            const activeTab = section.querySelector('[data-proof-tab].is-active');
            const activeKey = activeTab ? activeTab.dataset.proofTab : tabs[0]?.dataset.proofTab;
            if (activeKey) activateTab(section, activeKey, true);
          }
        });
      },
      { threshold: 0.25, rootMargin: '0px 0px -10% 0px' }
    );

    observer.observe(section);
  });
});
